<template>
    <div class="general-overview">
        <div class="general-overview_header">
            <div class="menu-item is-check">核心运营数据</div>
        </div>

        <el-scrollbar class="general-overview_content">
            <div class="content-analysis">
                <div class="analysis-item" v-for="item in coreData" :key="item.ref">
                    <div class="item-header">
                        <span>{{ item.label }}</span>

                        <el-popover popper-class="dark-popover" placement="top" width="200" trigger="hover" :content="item.tip">
                            <i class="el-icon-question" slot="reference" v-if="!!item.tip"></i>
                        </el-popover>
                    </div>

                    <div :class="['item-value', { 'down': item.count < 0 }]">
                        {{ item.count }}
                    </div>

                    <div class="item-chart" :ref="item.ref"></div>

                    <div class="item-trend">同比{{ item.trend }}% <i class="el-icon-caret-top"></i></div>
                </div>
            </div>

            <div class="content-detail">
                <div class="content-detail_header">
                    <div class="header-label">详细数据</div>

                    <el-button class="header-button" size="mini">下载数据</el-button>
                </div>

                <div class="content-detail_table">
                    <el-table
                        :data="tableData"
                        style="
                            width: 100%;
                            flex: 1;
                            border-radius: 4px;
                        "
                        size="medium"
                        :header-cell-style="{
                            fontWeight: 'normal',
                            color: '#333',
                            background: '#eef2fa',
                        }"
                        :cell-style="{ fontSize: '12px', color: '#333' }"
                        height="100%"
                    >
                        <el-table-column prop="date" label="日期"> </el-table-column>
                        <el-table-column prop="home" label="主页访问量"> </el-table-column>
                        <el-table-column prop="add_fan">
                            <template slot="header">
                                新增粉丝
                                <el-popover
                                    popper-class="dark-popover"
                                    placement="top"
                                    width="200"
                                    trigger="hover"
                                    content="新增粉丝数 = 昨日粉丝数 - 前日粉丝数，若出现负数可能是由于粉丝取关"
                                >
                                    <i
                                        class="el-icon-question"
                                        slot="reference"
                                        style="color: #c4c4c4; cursor: pointer; font-size: 16px"
                                    ></i>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fan" label="粉丝数"> </el-table-column>
                        <el-table-column prop="video_play" label="视频播放量"> </el-table-column>
                        <el-table-column prop="digg">
                            <template slot="header">
                                获得点赞数
                                <el-popover
                                    popper-class="dark-popover"
                                    placement="top"
                                    width="200"
                                    trigger="hover"
                                    content="新增点赞数 = 昨日点赞数 - 前日点赞数，若出现负数可能是由于取消点赞"
                                >
                                    <i
                                        class="el-icon-question"
                                        slot="reference"
                                        style="color: #c4c4c4; cursor: pointer; font-size: 16px"
                                    ></i>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column label="获得评论数" prop="comment">
                            <template slot="header">
                                获得评论数
                                <el-popover
                                    popper-class="dark-popover"
                                    placement="top"
                                    width="200"
                                    trigger="hover"
                                    content="新增评论数 = 昨日评论数 - 前日评论数，若出现负数可能是由于取消评论"
                                >
                                    <i
                                        class="el-icon-question"
                                        slot="reference"
                                        style="color: #c4c4c4; cursor: pointer; font-size: 16px"
                                    ></i>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column label="获得分享数" prop="share"> </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
import general from "@/utils/training-data/general.json";

export default {
    name: "GeneralOverview",
    data() {
        return {
            tableData: general[0].tableData,
            coreData: general[0].coreData,
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.setHomeChart();
            this.setAddFanChart();
            this.setFanChart();
            this.setVideoPlayChart();
        });
    },

    methods: {
        setChart(ref, data) {
            const chart = this.$echarts.init(ref);

            const options = {
                grid: {
                    top: 1,
                    left: 0,
                    bottom: 1,
                    right: 0,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false, // 避免额外间隙
                    data: data.x,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                },
                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                },
                series: [
                    {
                        data: data.y,
                        type: "line",
                        showSymbol: false,
                        smooth: true,
                        lineStyle: {
                            color: "#3b62e7",
                        },
                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#dee2fa", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "#ffffff", // 100% 处的颜色
                                    },
                                ],
                                global: false, // 缺省为 false
                            },
                        },
                    },
                ],
            };

            chart.setOption(options);
        },

        setHomeChart() {
            if (!this.$refs.homeRef[0]) return;
            const data = this.coreData[0].data;

            this.setChart(this.$refs.homeRef[0], data);
        },

        setAddFanChart() {
            if (!this.$refs.addFanRef[0]) return;
            const data = this.coreData[1].data;

            this.setChart(this.$refs.addFanRef[0], data);
        },

        setFanChart() {
            if (!this.$refs.fanRef[0]) return;
            const data = this.coreData[2].data;

            this.setChart(this.$refs.fanRef[0], data);
        },

        setVideoPlayChart() {
            if (!this.$refs.videoPlayRef[0]) return;
            const data = this.coreData[3].data;

            this.setChart(this.$refs.videoPlayRef[0], data);
        },
    },
};
</script>

<style lang="scss" scoped>
.general-overview {
    width: 100%;
    height: 100%;

    // background-color: rgba(0, 0, 0, 0.1);
    &_header {
        margin: 16px 24px 0;
        background-color: #ffffff;
        height: 64px;
        margin-bottom: 0;
        padding: 0 24px;
        box-shadow: 0 2px 8px #00000014;
        border-radius: 12px;
        display: flex;
        align-items: center;

        .menu-item {
            height: 100%;
            font-size: 16px;
            color: #323235;
            line-height: 64px;
            position: relative;
            cursor: pointer;

            &.is-check {
                font-weight: 600;

                &::before {
                    position: absolute;
                    content: "";
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 2px;
                    background-color: #2a55e5;
                }
            }
        }
    }

    &_content {
        height: calc(100% - 96px);
        margin-inline: 24px;
        // background-color: red;
        box-sizing: border-box;
        margin-top: 16px;

        ::v-deep .el-scrollbar__wrap {
            margin: 0 !important;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        ::v-deep .el-scrollbar__bar.is-vertical {
            display: none;
        }

        .content-analysis {
            background-color: #ffffff;
            border-radius: 12px;
            margin-bottom: 16px;
            padding: 24px 24px 16px;
            display: flex;
            gap: 16px;

            .analysis-item {
                width: 274px;
                height: 180px;
                padding: 16px;
                border: 1px solid #1618230f;
                border-radius: 4px;
                box-sizing: border-box;

                .item-header {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #666666;
                    gap: 4px;

                    .el-icon-question {
                        color: #999999;
                        cursor: pointer;
                    }
                }

                .item-value {
                    height: 32px;
                    // background-color: red;
                    margin-top: 12px;
                    font-weight: 600;
                    font-size: 30px;
                    display: flex;
                    align-items: center;

                    // &.down {
                    //     font-size: 14px;
                    //     color: #999999;
                    //     font-weight: 500;
                    // }
                }

                .item-chart {
                    // background-color: blue;
                    // border: 1px solid rgba(0, 0, 0, 0.1);
                    margin-top: 12px;
                    height: 48px;
                }

                .item-trend {
                    margin-top: 12px;
                    display: flex;
                    align-items: center;
                    gap: 4px;

                    color: #999999;

                    .el-icon-caret-top {
                        color: #7aca53;
                    }
                }
            }
        }

        .content-detail {
            border-radius: 12px;
            background-color: #ffffff;
            color: #333333;
            padding-bottom: 20px;

            &_header {
                padding: 20px 32px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14px;
            }

            &_table {
                margin-bottom: 20px;
            }
        }
    }
}
</style>
